import BreadCrumb from "components/Common/BreadCrumb";
import TableContainer from "components/Common/TableContainer";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import moment from "moment";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import { createSelector } from "reselect";
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params";
import LabelWrapper from "components/Common/LabelWrapper";
import CountUp from "react-countup";
import { getSPUsers, getUsers } from "store/user/thunk";
import CollapseFilter from "components/Common/CollapseFilter";
import DatePickerCustom from "components/Common/DatePickerCustom";
import DropdownCountries from "components/Common/DropdownCountries";
import DropdownPlatform from "components/Common/DropdownPlatform";
import ModalPreview from "components/Common/ModalPreview";
import {
  LIST_AGENCY_OPTION,
  LIST_OPTION_OS,
  LIST_OPTION_PLATFORM,
  getPlatFormImage,
} from "helpers/constans";
import { formatDateStringToKorea, formatISOString } from "helpers/format";
import { capitalizeFirstLetter } from "utils";
import avatar1 from "../../assets/images/users/ic_defaul_avatar2.png";
import countries from "helpers/countries";
import DropdownAsyncAgency from "components/Common/DropdownAsyncAgency";
import UserDetail from "./UserDetail";
import userApi from "api/userApi";
import TooltipCustom from "components/Common/TooltipCustom";
import { Link } from "react-router-dom";
import DropdownAsyncCourse from "components/Common/DropdownAsyncCourse";
import { getLoggedInUserInfo } from "api/axiosClient";

interface Option {
  label: string;
  value: string;
}

registerLocale("en", en);
registerLocale("ko", ko);

const UserList = () => {
  const { t, i18n } = useTranslation();
  const dispatch: any = useDispatch();

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 30),
    name: withDefault(StringParam, ""),
    email: withDefault(StringParam, ""),
    ip: withDefault(StringParam, ""),
    provider: withDefault(StringParam, ""),
    os: withDefault(StringParam, ""),
    country_code: withDefault(StringParam, ""),
    is_active: withDefault(StringParam, ""),
    created_from: withDefault(StringParam, ""),
    created_to: withDefault(StringParam, ""),
    agency_id: withDefault(StringParam, ""),
    campaign: withDefault(StringParam, ""),
    course_id: withDefault(StringParam, ""),
  });

  const [itemToDetail, setItemToDetail] = useState<any>(false);
  const [roleAuth, setRoleAuth] = useState<string>();

  const LIST_OPTION_OS_LANG =
    LIST_OPTION_OS?.map((item: any) => ({
      value: item?.value,
      label: t(item?.label),
    })) || [];

  const [nickNameSearch, setNicknameSearch] = useState<string>(
    query?.name || ""
  );
  const [emailSearch, setEmailSearch] = useState<string>(query?.email || "");

  const [platFormSearch, setPlatFormSearch] = useState<Option | null>(
    LIST_OPTION_PLATFORM?.filter(
      (item) => String(item?.value) === String(query?.provider)
    )[0]
  );
  const [oSSearch, setOSSearch] = useState<Option | null>(
    LIST_OPTION_OS_LANG?.filter(
      (item) => String(item?.value) === String(query?.os)
    )[0]
  );

  const [ipAddressSearch, setIPAddressSearch] = useState<string>(
    query?.ip || ""
  );

  const [agencySearch, setAgencySearch] = useState<Option | any>(
    LIST_AGENCY_OPTION?.find((item) => item?.value === query?.agency_id)
      ?.value || {
      label: t("All Filter"),
      value: "all",
    }
  );

  const [courseSearch, setCourseSearch] = useState<Option | any>({
    name: t("All Filter"),
    value: "all",
    id: "all",
  });

  const [dateSearch, setDateSearch] = useState<any[]>([
    query?.created_from
      ? moment(query?.created_from || "", "Y-MM-DD").toDate()
      : null,
    query?.created_to
      ? moment(query?.created_to || "", "Y-MM-DD").toDate()
      : null,
  ]);
  const [created_from, created_to] = dateSearch;

  const [linkImage, setLinkImage] = useState<string>("");
  const [countrySearch, setCountrySearch] = useState<any | null>(null);
  const [listCountry, setListCountry] = useState<any>([]);

  const selectLayoutState = (state: any) => state.User;
  const UserProperties = createSelector(selectLayoutState, (state) => ({
    users: state.spUsers,
    isUserLoading: state.isSPUserLoading,
    isUserSuccess: state.isSPUserSuccess,

    error: state.error,
  }));

  // Inside your component
  const { users, isUserLoading } = useSelector(UserProperties);

  function loadTableData() {
    dispatch(getSPUsers(query));
  }

  useEffect(() => {
    loadTableData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, JSON.stringify(query)]);

  const searchData = () => {
    setQuery({
      ...query,
      name: nickNameSearch.trim() || "",
      email: emailSearch.trim() || "",
      country_code: countrySearch || "",
      provider: platFormSearch?.value || "",
      os: oSSearch?.value || "",
      course_id: courseSearch?.value !== "all" ? courseSearch?.value ?? "" : "",
      ip: ipAddressSearch.trim() || "",
      created_from: created_from ? formatISOString(created_from, "start") : "",
      created_to: created_to ? formatISOString(created_to, "end") : "",

      ...(agencySearch?.value !== "all"
        ? { agency_id: agencySearch?.value }
        : { agency_id: "" }),
      //sort_by: TYPE_SELECT_DEFAULT,
      page: 1,
      time_request: +new Date(),
    });
  };

  const resetData = () => {
    setQuery(
      {
        name: "",
        email: "",
        country_code: "",
        provider: "",
        os: "",
        ip: "",
        created_from: "",
        created_to: "",
        agency_id: "",
        course_id: "",
        sort_by: "",
        time_request: +new Date(),
        page: 1,
      },
      "push"
    );
    setNicknameSearch((_prev) => "");
    setEmailSearch("");
    setPlatFormSearch((_prev) => null);
    setOSSearch((_prev) => null);
    setCountrySearch((_prev: any) => null);
    setIPAddressSearch((_prev) => "");
    setDateSearch([null, null]);
    setAgencySearch({
      label: t("All Filter"),
      value: "all",
    });
    setCourseSearch({
      name: t("All Filter"),
      value: "all",
      id: "all",
    });
  };

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 60,
        thClass: "whitespace-nowrap",
        Cell: ({ ...props }) => {
          return (
            <div style={{ width: 35 }}>
              {users?.pagination?.total -
                ((query?.page - 1) * query?.limit + props?.row?.index)}
            </div>
          );
        },
      },
      {
        Header: t("Photo"),
        accessor: "profile_image_url",
        thClass: "text-center whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 80,
        Cell: (cell: any) => (
          <>
            <div className="w-100 text-center " style={{ minWidth: "60px" }}>
              <div
                style={{ width: "45px" }}
                className="m-auto cursor-pointer"
                onClick={() =>
                  cell?.value && setLinkImage((prev) => cell?.value)
                }
              >
                <img
                  src={cell?.value ?? avatar1}
                  className="rounded-circle avatar-sm"
                  alt="thumbnail"
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = avatar1;
                  }}
                />
              </div>
            </div>
          </>
        ),
      },

      {
        Header: t("Nickname"),
        accessor: "name",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          return (
            <>
              <div className="cursor-pointer">{cell?.value || "-"}</div>
            </>
          );
        },
      },

      {
        Header: t("Email"),
        accessor: "email",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          return (
            <>
              <div className="cursor-pointer">{cell?.value || "-"}</div>
            </>
          );
        },
      },
      {
        Header: t("Platform"),
        accessor: "provider",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 180,
        Cell: (cell: any) => {
          let provider = cell?.row?.original?.provider;

          let imgPlatform = getPlatFormImage(provider);
          return (
            <div className="d-flex flex-column gap-1">
              <div className="cursor-pointer d-flex gap-2 align-items-center whitespace-nowrap">
                <div style={{ width: "25px" }}>
                  {imgPlatform && (
                    <img
                      src={imgPlatform}
                      width={25}
                      height={25}
                      alt="provider"
                    />
                  )}
                </div>
                <div className="cursor-pointer">
                  {t(
                    capitalizeFirstLetter(
                      provider === "default" ? "Email" : provider
                    )
                  )}
                </div>
              </div>
            </div>
          );
        },
      },
      {
        Header: t("IP"),
        accessor: "ip",
        thClass: "whitespace-nowrap",
        filterable: true,
        sortable: false,
        Cell: (cell: any) => {
          const ip = cell?.row?.original?.ip;
          return ip || "-";
        },
      },
      {
        Header: t("Country"),
        accessor: "country",
        thClass: "whitespace-nowrap",
        filterable: true,
        sortable: false,
        Cell: (cell: any) => {
          const countryCode = cell?.row?.original?.country_code;
          const country = countries.find((item) => item?.code === countryCode);

          return countryCode ? (
            <div
              className="d-flex flex-column gap-1"
              style={{ minWidth: "130px" }}
            >
              {
                <div className="cursor-pointer d-flex gap-2 align-items-center ">
                  {country && (
                    <>
                      <img
                        src={country?.flags}
                        width={20}
                        height={20}
                        alt="profile"
                      />
                      <div className="cursor-pointer">
                        {i18n?.language === "ko"
                          ? country?.name_korea
                          : country?.name}
                      </div>
                    </>
                  )}
                </div>
              }
            </div>
          ) : (
            <div>-</div>
          );
        },
      },
      {
        Header: `${t("Agency")}`,
        accessor: "AgencyName",
        filterable: false,
        sortable: false,
        thWidth: 140,
        thClass: "text-center whitespace-nowrap",
        Cell: (cell: any) => {
          const agencies: any = cell?.row?.original?.agencies;
          return agencies?.length > 0 ? (
            agencies?.map((item: any) => {
              return (
                <div className="text-center" key={item?.id}>
                  <div>{item?.name}</div>
                  <div className="text-primary">{item?.code}</div>
                </div>
              );
            })
          ) : (
            <div className="text-center">-</div>
          );
        },
      },
      {
        Header: t("Created at"),
        accessor: "created_at",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "100px" }}>
              <span>
                <span>{arrDate?.[0] || ""}</span> <br />{" "}
                <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Button Action"),
        thClass: "text-center",
        thWidth: 150,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <ul
              className="list-inline d-flex flex-wrap hstack gap-2 mb-0"
              style={{ width: "150px", justifyContent: "center" }}
            >
              <TooltipCustom
                title={t("View Detail")}
                id={`view-md-${item?.id}`}
              >
                <Link
                  className="btn btn-sm btn-soft-primary edit-item-btn"
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setItemToDetail(item);
                  }}
                >
                  <i className="ri-eye-fill align-bottom "></i>
                </Link>
              </TooltipCustom>
            </ul>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [i18n?.language, users?.pagination?.total, query?.page]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return { ..._prev, ...sortBy };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangePicker = (values: any[] = []) => {
    setDateSearch((_prev: any) => values);
  };

  const onCloseImageClick = () => {
    setLinkImage((_prev) => "");
  };

  const handleCloseModal = () => {
    setItemToDetail(null);
  };

  useEffect(() => {
    document.title = `${t("User")} | Picaverse Agency Star+`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  useEffect(() => {
    const handleCallAllOption = async () => {
      try {
        const [resCountry]: any = await Promise.all([
          userApi.spUsersCountries({ page: 1, limit: 200 }),
        ]);
        setListCountry((_prev: any) => resCountry?.data || []);
      } catch (error: any) {
        return error;
      }
    };
    const role = getLoggedInUserInfo();
    setRoleAuth(role?.user?.role);

    handleCallAllOption();
  }, []);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("User Management")} pageTitle={t("Home")} />
          <Row>
            <Col lg={12}>
              <Card
                id="customerList"
                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
              >
                <CardHeader className="border-0">
                  <Row className="g-4 align-items-center">
                    <div className="col-sm">
                      <div>
                        <h5 className="card-title mb-0">
                          <span className="me-2">{t("Total")}:</span>
                          <CountUp
                            start={0}
                            end={users?.pagination?.total || 0}
                            duration={1}
                            className="text-primary"
                          />
                        </h5>
                      </div>
                    </div>
                  </Row>
                </CardHeader>
                <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                  <CollapseFilter>
                    <Row className="g-4 align-items-center mt-0 mt-md-2">
                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={`${t("Name")}`}
                          isShow={!!nickNameSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Name")}...`}
                            value={nickNameSearch}
                            onChange={(e) => setNicknameSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper label={t("Email")} isShow={!!emailSearch}>
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Email")}...`}
                            value={emailSearch}
                            onChange={(e) => setEmailSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={t("IP Address")}
                          isShow={!!ipAddressSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("IP Address")}...`}
                            value={ipAddressSearch}
                            onChange={(e) => setIPAddressSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper label={t("Platform")} isShow={true}>
                          <DropdownPlatform
                            name="provider"
                            placeholder={`${t("Platform")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={platFormSearch || null}
                            onChangeSelect={(e: any) => setPlatFormSearch(e)}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Country")} isShow={true}>
                          <DropdownCountries
                            name="country"
                            dataList={listCountry || []}
                            placeholder={`${t("Select Country")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={countrySearch || ""}
                            onChangeSelect={(e: any) =>
                              setCountrySearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                          />
                        </LabelWrapper>
                      </Col>
                      {roleAuth === "agency" ? (
                        <Col
                          sm={12}
                          md={3}
                          xl={3}
                          xxl={3}
                          className="mt-3 mt-md-3"
                        >
                          <LabelWrapper label={t("Course")} isShow={true}>
                            <DropdownAsyncCourse
                              name={`course_id`}
                              onChangeSelect={(event: any) => {
                                console.log(event?.data);
                                if (event?.value === "all") {
                                  setCourseSearch({
                                    id: "all",
                                    name: "All",
                                    value: "all",
                                    label: "All",
                                  });
                                } else {
                                  setCourseSearch({
                                    ...event?.data,
                                    value: event?.value,
                                  });
                                }
                              }}
                              isMulti={false}
                              placeholder={`${t("Select Course")}...`}
                              isShowIconCheck={false}
                              isAllOption={true}
                              listCheckedCourse={courseSearch}
                              isClearable={false}
                            />
                          </LabelWrapper>
                        </Col>
                      ) : (
                        <Col
                          sm={12}
                          md={3}
                          xl={3}
                          xxl={3}
                          className="mt-3 mt-md-3"
                        >
                          <LabelWrapper label={t("Agency")} isShow={true}>
                            <DropdownAsyncAgency
                              name="agency_id"
                              onChangeSelect={(event: any) => {
                                setAgencySearch(event);
                              }}
                              isMulti={false}
                              placeholder={`${t("Select Agency")}...`}
                              isShowIconCheck={false}
                              listCheckedUsers={agencySearch}
                              isAllOption={true}
                              isNotBelongToAgency={true}
                              isClearable={false}
                            />
                          </LabelWrapper>
                        </Col>
                      )}

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-sm-4 mt-md-3 mt-3 date-picker-wrapper-custom"
                      >
                        <LabelWrapper
                          label={t("Date")}
                          isShow={!!created_from || !!created_to}
                        >
                          <DatePickerCustom
                            startDate={created_from || null}
                            endDate={created_to || null}
                            onChangePicker={handleChangePicker}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        lg={3}
                        className="hstack gap-1 justify-content-center justify-content-md-end mt-sm-4 mt-md-3"
                      >
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-1"
                            onClick={searchData}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t("Button Search")}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t("Button Reset")}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </CollapseFilter>
                </div>
                <CardBody className="pt-3">
                  <div>
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass="align-middle table-bordered-dashed"
                      theadClass="table-light text-muted"
                      columns={columns}
                      data={users?.items?.length ? users?.items : []}
                      customPageSize={query.limit}
                      customPageIndex={query.page - 1}
                      totalRecords={users?.pagination?.total}
                      customPageCount={Math.ceil(
                        Number(users?.pagination?.total) / Number(query.limit)
                      )}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      sorting={{
                        sort_by: query.sort_by,
                        order_by: query.order_by,
                      }}
                      handleChangeSorting={handleChangeSorting}
                      isLoading={isUserLoading}
                    />
                  </div>
                  <ToastContainer closeButton={false} limit={1} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        {itemToDetail && (
          <Modal
            isOpen={!!itemToDetail}
            centered={true}
            size="xl"
            className=""
            scrollable={false}
          >
            <ModalHeader toggle={handleCloseModal}>
              {`${itemToDetail?.name} - ${itemToDetail?.email}` || ""}
            </ModalHeader>
            <ModalBody>
              <UserDetail
                userId={itemToDetail?.id}
                setLinkImage={setLinkImage}
                listCountry={listCountry}
              />
            </ModalBody>
          </Modal>
        )}

        <ModalPreview
          type={"IMAGE"}
          isOpen={!!linkImage}
          url={linkImage}
          onClose={() => onCloseImageClick()}
        />
      </div>
    </React.Fragment>
  );
};

export default UserList;
